import React, { useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, MessageCircle, User, LogOut, Key, FileText } from 'lucide-react';
import { AppContext } from '../../Context';
import './MobileNavbar.scss';

const MobileNavbar = () => {
  const { isAuth, logOut, currentUser } = useContext(AppContext);
  const location = useLocation();
  const navigate = useNavigate();

  // Si el usuario no está autenticado, no mostrar la barra de navegación
  if (!isAuth) return null;

  // Determinar qué tab está activo basado en la ruta actual
  const isActive = (path) => {
    if (path === '/dashboard' && location.pathname === '/dashboard') return true;
    if (path === '/chat' && location.pathname.includes('/chat')) return true;
    if (path === '/profile' && location.pathname.includes('/profile')) return true;
    if (path === '/signout' && location.pathname.includes('/signout')) return true;
    if (path === '/master' && location.pathname.includes('/master')) return true;
    if (path === '/registro-log' && location.pathname === '/registro-log') return true;
    return false;
  };

  const handleLogout = async () => {
    await logOut();
    navigate('/');
  };

  return (
    <div className="mobile-navbar">
      <div className="mobile-navbar-container">
        <Link to="/dashboard" className={`mobile-navbar-item ${isActive('/dashboard') ? 'active' : ''}`}>
          <div className="icon-container">
            <Home size={22} />
          </div>
          <span>Inicio</span>
        </Link>
        
        <Link to="/chat" className={`mobile-navbar-item mobile-navbar-item--chat ${isActive('/chat') ? 'active' : ''}`}>
          <div className="icon-container">
            <MessageCircle size={22} />
          </div>
          <span>Chat</span>
        </Link>
        
        <Link to="/dashboard/profile" className={`mobile-navbar-item ${isActive('/profile') ? 'active' : ''}`}>
          <div className="icon-container">
            <User size={22} />
          </div>
          <span>Perfil</span>
        </Link>
        
        <div onClick={handleLogout} className={`mobile-navbar-item ${isActive('/signout') ? 'active' : ''}`}>
          <div className="icon-container">
            <LogOut size={22} />
          </div>
          <span>Salir</span>
        </div>
        
        {currentUser && currentUser.isMaster && (
          <Link to="/master" className={`mobile-navbar-item ${isActive('/master') ? 'active' : ''}`}>
            <div className="icon-container">
              <Key size={22} />
            </div>
            <span>Master</span>
          </Link>
        )}
        {currentUser?.isSuperAdmin === true && (
          <Link to="/registro-log" className={`mobile-navbar-item ${isActive('/registro-log') ? 'active' : ''}`}>
            <div className="icon-container">
              <FileText size={22} />
            </div>
            <span>Registro log</span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default MobileNavbar;
